import { SortWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Sort')
export class SortConnectorProvider extends ConnectorProvider<SortWorkflowNode> {}
